/**
 * * Варианты FilePreview компонента
 */
export enum FilePreviewVariantEnum {
  /**Обычный*/
  Regular = "regular",
  /**Уменьшенный */
  Small = "small",
  /**Строковый */
  Inline = "inline",
}